module.exports = __webpack_public_path__ + "img/adaptations9.14662958.png";